module.exports = __webpack_public_path__ + "static/background-1b1ae10ba88e11945e95b45966049484.jpg";